import './Legal.css';
import SEO from '../../components/SEO/SEO';

function TermsConditions() {
    return (
        <div className='legal_container padding_top padding_bottom'>
            <SEO
                title="Terms and Conditions"
                description="Read the terms and conditions for using PrepWize, our AI-powered meal planning app."
                url="https://prepwize.ai/terms-and-conditions"
            />
            <div className='all_margin'>
                <div className='margin_auto_width'>
                    <br />
                    <br />
                    <h2>Terms and Conditions</h2>
                    <br />
                    <p className='gray_scale_2 font_size_18'>
                        By accessing or using PrepWize, a product of Revennt, LLC ("we," "us," or "our"), you agree to be bound by the following Terms and Conditions ("Terms"). If you do not agree to these Terms, do not use our services.
                    </p>

                    <h3>1. Use of the Service</h3>
                    <p>
                        PrepWize offers tools for meal planning, nutritional tracking, and AI-powered features including but not limited to chat support, recipe generation, and meal recognition through image analysis. You agree to use the service only for lawful, personal, and non-commercial purposes.
                    </p>

                    <h3>2. Accounts and Registration</h3>
                    <p>
                        To access certain features, you may be required to register for an account. You are solely responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.
                    </p>

                    <h3>3. Collection of Personal Information</h3>
                    <p>
                        By using PrepWize, you consent to the collection and processing of personal data including, but not limited to, your name, email address, height, weight, age, dietary goals, meal photos, and chat interactions. This data is used to deliver personalized experiences and improve our services. We apply reasonable security measures to protect your data, but no system is entirely immune to risk.
                    </p>

                    <h3>4. AI Features and Data Usage</h3>
                    <p>
                        PrepWize utilizes artificial intelligence for various features, including meal recognition from uploaded images and chat-based nutritional guidance. Images and chat inputs may be processed by AI models, either proprietary or third-party. By using these features, you consent to this data being analyzed for the purpose of providing relevant suggestions, insights, and services. We do not use your data to train public AI models, and your data is not sold to third parties.
                    </p>

                    <h3>5. Emails and Communication</h3>
                    <p>
                        By creating an account, you agree to receive emails from us, which may include service updates, transactional notices, and marketing material. You can opt out of promotional emails at any time, but transactional messages (e.g., account or security-related notifications) will still be sent.
                    </p>

                    <h3>6. Subscription and Payments</h3>
                    <p>
                        PrepWize Pro is a paid subscription that unlocks premium features. By subscribing, you authorize us to charge your selected payment method on a recurring basis. Pricing and features may change, but you will be notified of any material updates before they take effect.
                    </p>

                    <h3>7. Cancellation and Refunds</h3>
                    <p>
                        You can cancel your subscription at any time via your account settings. Except where legally required, all payments are final and non-refundable. Refunds, if any, are granted at our sole discretion.
                    </p>

                    <h3>8. User Content</h3>
                    <p>
                        You retain ownership of all content you submit, including recipes, preferences, photos, and chat entries ("User Content"). You grant us a non-exclusive, royalty-free, worldwide license to use, display, and process this content for the purpose of operating and improving the service. You are responsible for ensuring that your User Content does not violate any law or third-party rights.
                    </p>

                    <h3>9. Prohibited Conduct</h3>
                    <p>
                        You agree not to: (i) misuse or interfere with the service; (ii) upload unlawful or harmful content; (iii) reverse-engineer, tamper with, or hack the platform; (iv) use the platform in violation of any applicable law or regulation.
                    </p>

                    <h3>10. Intellectual Property</h3>
                    <p>
                        All software, design, text, images, and other content on PrepWize (excluding your User Content) is the intellectual property of Revennt, LLC or its licensors and is protected by copyright, trademark, and other applicable laws.
                    </p>

                    <h3>11. Disclaimer of Warranties</h3>
                    <p>
                        The service is provided "as is" and "as available" without warranties of any kind. We do not guarantee the accuracy, reliability, or appropriateness of any AI-generated suggestions, including but not limited to nutritional advice, meal plans, or recipe recommendations.
                        <br /><br />
                        <strong>Health Disclaimer:</strong> The information provided by PrepWize, including AI-powered features such as chat and image-based meal analysis, is for informational purposes only and does not constitute professional medical advice, diagnosis, or treatment. Always seek the guidance of a qualified healthcare provider before making decisions related to your diet, health, or nutrition. You assume full responsibility for any actions taken based on information obtained through the service.
                        <br /><br />
                        Use of PrepWize is at your own risk.
                    </p>

                    <h3>12. Limitation of Liability</h3>
                    <p>
                        To the fullest extent permitted by law, Revennt, LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of your access to or use of the service. This includes, but is not limited to, reliance on any AI-generated recommendations or nutritional insights.
                    </p>

                    <h3>13. Termination</h3>
                    <p>
                        We reserve the right to suspend or terminate your account at any time, with or without notice, if you violate these Terms or if we believe your use of the service poses a risk to us or other users.
                    </p>

                    <h3>14. Changes to These Terms</h3>
                    <p>
                        We may revise these Terms at any time. Updates will be posted on this page with a new effective date. Continued use of the service after changes are posted constitutes your acceptance of the revised Terms.
                    </p>

                    <h3>15. Contact Us</h3>
                    <p>
                        If you have questions or concerns regarding these Terms, please contact us at: <a href="mailto:support@prepwize.ai">support@prepwize.ai</a>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default TermsConditions;
